/**
 * `/raporty/katalog` — the trainer's own question shelf (R35).
 *
 * A path and a screen. A STATIC segment above `/raporty/$templateId`, so „katalog" can never be
 * read as a template id. The screen owns its one read and every narrowing of it; nothing about the
 * shelf lives here.
 */

import { createFileRoute } from '@tanstack/react-router';

import { QuestionShelfScreen } from '~/pages/reports';

export const Route = createFileRoute('/_shell/raporty/katalog')({
  component: QuestionCatalogRoute,
});

function QuestionCatalogRoute() {
  return <QuestionShelfScreen />;
}
